import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IDocumentControlModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: DocumentControlModuleConfigToken, useValue: documentControlModuleConfig },
 * ],
 */
const DocumentControlModuleConfigToken = new InjectionToken('document_control_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { DocumentControlModuleConfigToken };

//# sourceMappingURL=mt-ng2-document-control-config.js.map